module.exports = __webpack_public_path__ + "img/cul_1.cbc5b833.png";